// @flow
import React, { PureComponent } from 'react';
import CONST from 'app/common/lib/Const';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { Box, Text } from 'gestalt';

type PropType = {
  onGotItClick: () => void,
};

const THRESHOLD = 10;

export class AuthEuCookieBar extends PureComponent<PropType, { isVisible: boolean }> {
  static propTypes = {
    onGotItClick: PropTypes.func,
  };

  state: { isVisible: boolean } = { isVisible: true };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);

    this.onScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll = throttle(() => {
    const scrollTop = this.getScrollPos();
    if (scrollTop > THRESHOLD) {
      this.setState({ isVisible: false });
    } else if (scrollTop === 0) {
      this.setState({ isVisible: true });
    }
  });

  getScrollPos() {
    if (window.scrollY !== undefined) {
      // Modern browser.
      return window.scrollY;
    } else if (document.documentElement && document.documentElement.scrollTop !== undefined) {
      // IE support.
      return document.documentElement.scrollTop;
    }
    return 0;
  }

  hide() {
    if (!this.state.isVisible) {
      return;
    }
    this.setState({ isVisible: false });
  }

  show() {
    if (this.state.isVisible) {
      return;
    }
    this.setState({ isVisible: true });
  }

  handleLearnMoreClick() {
    trackRegisterAction('auth_eu_cookie_banner_learnmore');
  }

  handlePrivacyClick() {
    trackRegisterAction('auth_eu_cookie_banner_privacy');
  }

  handleGotItClick = () => {
    trackRegisterAction('auth_eu_cookie_banner_dismissed');
    if (this.props.onGotItClick) {
      this.props.onGotItClick();
    }
  };

  render() {
    const { isVisible } = this.state;

    const cookieBarStyles = {
      __style: {
        animation: isVisible ? 'fadeIn .5s' : 'fadeOutAndHide .5s forwards',
        backgroundColor: '#1c232c',
        opacity: 0.8,
        zIndex: 1000,
      },
    };

    return (
      <div className="EuCookieBar">
        <Box
          alignItems="center"
          bottom
          dangerouslySetInlineStyle={cookieBarStyles}
          height={36}
          justifyContent="between"
          position="fixed"
          xs={{ column: 12, display: 'flex' }}
        >
          <Box deprecatedPadding={{ x: 2 }}>
            <NavigateLink
              onClick={this.handlePrivacyClick}
              style={{ color: 'white' }}
              to={CONST.GEN.templateConst.settings.ABOUT_PRIVACY_URL}
            >
              {i18n._('Privacy', 'Accessible label for the Privacy link in the EU cookie bar')}
            </NavigateLink>
          </Box>
          <Box display="flex" alignItems="center">
            <Box deprecatedPadding={{ x: 1 }}>
              <Text color="gray" inline size="sm" smSize="xs" mdSize="xs" lgSize="sm">
                {i18n._(
                  'Pinterest is using cookies to help give you the best experience we can.',
                  'Accessible label for the cookie text description in the EU cookie bar',
                )}
              </Text>
            </Box>
            <Box deprecatedPadding={{ x: 1 }}>
              <NavigateLink
                onClick={this.handleLearnMoreClick}
                style={{ color: 'white' }}
                to={CONST.GEN.templateConst.settings.ABOUT_COOKIE_URL}
              >
                {i18n._(
                  'Learn More',
                  'Accessible label for the Learn More link in the EU cookie bar',
                )}
              </NavigateLink>
            </Box>
            <Box deprecatedPadding={{ x: 1 }}>
              <button className="Button borderless cookieButton" onClick={this.handleGotItClick}>
                {i18n._('Got it!', 'Accessible label for the Got it! button in the EU cookie bar')}
              </button>
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}

export default AuthEuCookieBar;
